import React from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";

interface headerProps {
    title: any;
    component?: any;
    children?: React.ReactNode;
    headerContainerStyle?: SxProps<Theme> | undefined;
}

const CustomHeader = (props: headerProps) => {
    const { title, component } = props;
    return (
        <Box
            className="title-bar"
            sx={props?.headerContainerStyle ? props?.headerContainerStyle : {
                // boxShadow: "0 1px 3px #c7c9c8",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 3,
                minHeight: "65px",
                // transform: "translateY(0)",

                // background: themeMode === "dark" ? "#101418 !important" : "#fff",
            }
            }
        >
            {component}
            {
                title && <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
                    {title}
                </Typography>
            }
            {props.children}
        </Box >
    );
};

export default CustomHeader;